"use client";

import getLogger from "@/lib/logger";
import { datadogRum } from "@datadog/browser-rum";
import { signOut } from "next-auth/react";

const logger = getLogger("useSignOut");

export function useSignOut() {
  return () => {
    try {
      datadogRum.clearUser();
    } catch (error) {
      logger.error(error, "Failed to clear Datadog user on sign-out");
    }
    signOut({
      callbackUrl: "/auth/login",
      redirect: true,
    });
  };
}
